import React from "react";
import FlowerImage from "../../assets/images/2018/Logo.png";
import "./styles.less";

const Loading = props => (
  <div className="loadingScreen">
    <img src={FlowerImage} />
    {props.text ? <p>{props.text}</p> : null}
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./components/Controls/Loading.js